export const navigation = [
  {
    name: 'Acts',
    url: '/',
    icon: 'icon-book-open',
    feature: 'acts'
  }, {
    name: 'Users',
    url: '/users/list',
    icon: 'icon-people',
    feature: 'users/list'
  }
];



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/_nav.ts